import { getMySubscriptionsRequest, getMyPurchasesRequest } from '@services'
import { subscriptionStore, purchasesStore, authStore } from '@stores'
import useAsync from '@shared/js/composables/useAsync.js'

export default function () {
  const { fetchedSubscriptions, setMySubscriptions } = subscriptionStore()
  const { fetchedPurchases, setMyPurchases } = purchasesStore()
  const { isLoggedIn } = authStore()

  const {
    error: errorSubs,
    data: dataSubs,
    run: runSubs,
  } = useAsync(getMySubscriptionsRequest)

  const {
    error: errorPurchases,
    data: dataPurchases,
    run: runPurchases,
  } = useAsync(getMyPurchasesRequest)

  async function fetchSubs(force) {
    if (isLoggedIn.value && (!fetchedSubscriptions.value || force)) {
      await runSubs()

      if (!errorSubs.value) {
        setMySubscriptions(dataSubs.value.data)
        fetchedSubscriptions.value = true
      }
    }
  }

  async function fetchPurchases(force) {
    if (isLoggedIn.value && (!fetchedPurchases.value || force)) {
      await runPurchases()

      if (!errorPurchases.value) {
        setMyPurchases(dataPurchases.value.data)
        fetchedPurchases.value = true
      }
    }
  }

  return {
    fetchPurchases,
    fetchSubs,
  }
}
